import React from 'react';
import { Check } from 'lucide-react';

export const StepProgress = ({ currentStep }) => {
  return (
    <div className="flex items-center justify-center mb-10">
      {[1, 2, 3].map((s) => (
        <React.Fragment key={s}>
          <div 
            className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all ${
              s === currentStep ? 'text-white' :
              s < currentStep ? 'text-white' : ''
            }`} 
            style={{
              borderColor: s <= currentStep ? 'var(--color-navy)' : 'var(--color-border)',
              backgroundColor: s <= currentStep ? 'var(--color-navy)' : 'transparent',
              color: s <= currentStep ? 'white' : 'var(--color-muted)'
            }}
          >
            {s < currentStep ? <Check className="w-5 h-5" /> : s}
          </div>
          {s < 3 && (
            <div 
              className="w-20 h-0.5" 
              style={{ backgroundColor: s < currentStep ? 'var(--color-navy)' : 'var(--color-border)' }} 
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
